"use strict";
/*
 * Created on 25. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Data converter for {@link ReleaseActionFeasibility}.
 * @author Radek Beran
 */


var ReleaseActionFeasibilityConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ReleaseActionFeasibilityConverter, _DataObjectConverter_);

  function ReleaseActionFeasibilityConverter() {
    _classCallCheck(this, ReleaseActionFeasibilityConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReleaseActionFeasibilityConverter).apply(this, arguments));
  }

  return ReleaseActionFeasibilityConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ReleaseActionFeasibilityConverter = ReleaseActionFeasibilityConverter;